import { render, staticRenderFns } from "./pageBreadcrumb.vue?vue&type=template&id=087dbdb4&scoped=true&"
import script from "./pageBreadcrumb.vue?vue&type=script&lang=js&"
export * from "./pageBreadcrumb.vue?vue&type=script&lang=js&"
import style0 from "./pageBreadcrumb.vue?vue&type=style&index=0&id=087dbdb4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "087dbdb4",
  null
  
)

export default component.exports